module.exports = __webpack_public_path__ + "static/media/landing_customer_carousel_2.82d3b51b.svg";